import { z } from "zod";

export const FATIGUE_FLIGHT_EVENT_TYPE = "fatigue";
export const SINK_RATE_FLIGHT_EVENT_TYPE = "sink_rate_exceeded";

export const FatigueTriggerTypeSchema = z.enum([
	"duty_day_duration",
	"flight_time",
	"legs",
]);

export type FatigueTriggerType = z.infer<typeof FatigueTriggerTypeSchema>;

export const FlightFatigueTriggerSchema = z.object({
	actual: z.number(),
	limit: z.number(),
	type: FatigueTriggerTypeSchema,
	unit: z.enum(["count", "hours"]),
});

export type FlightFatigueTrigger = z.infer<typeof FlightFatigueTriggerSchema>;

export const FatigueEventDataSchema = z.object({
	triggers: z.array(FlightFatigueTriggerSchema),
	type: z.literal(FATIGUE_FLIGHT_EVENT_TYPE),
});
export const SINK_RATE_BAND_CEILING_FT = 1000;
export const SINK_RATE_BAND_FLOOR_FT = 500;

export const SinkRateBandSchema = z.enum([
	"a",
	"b",
	"no_elevation",
]);

export type SinkRateBand = z.infer<typeof SinkRateBandSchema>;

export const SINK_RATE_BAND_THRESHOLDS_FPM: Record<SinkRateBand, number> = {
	a: -1500,
	b: -1200,
	no_elevation: -1200,
};

export const SinkRateEventDataSchema = z.object({
	aglFt: z.number().nullable(),
	band: SinkRateBandSchema,
	datumOffsetFt: z.number().nullable().optional(),
	elevationSource: z.enum([
		"airport",
		"none",
		"post_arrival_anchor",
		"runway_tdze",
		"touchdown_anchor",
	]),
	fieldElevationFt: z.number().nullable(),
	peakSinkRateFpm: z.number(),
	/** Ground in the track's own datum; AGL is relative to this, not to fieldElevationFt. */
	referenceAltitudeFt: z.number().nullable().optional(),
	provider: z.enum([
		"fr24",
		"flightaware",
		"airsync",
		"adsbx",
		"garmin",
	]),
	runDurationSeconds: z.number(),
	runEnd: z.string(),
	runSampleCount: z.number().int(),
	runStart: z.string(),
	thresholdFpm: z.number(),
	type: z.literal(SINK_RATE_FLIGHT_EVENT_TYPE),
});

export type SinkRateEventData = z.infer<typeof SinkRateEventDataSchema>;

// Only empty legacy event data may omit the type discriminator.
export const FlightEventDataSchema = z.union([
	FatigueEventDataSchema,
	SinkRateEventDataSchema,
	z.strictObject({}),
]);

export type FlightEventData = z.infer<typeof FlightEventDataSchema>;
